import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  useTheme,
} from '@mui/material';
import { alpha } from '@mui/material/styles';

import { en } from '../../locale';

interface UnsavedChangesDialogProps {
  open: boolean;
  changeCount: number;
  loading?: boolean;
  onStay: () => void;
  onLeaveWithoutSaving: () => void;
  onSaveAndLeave: () => void;
}

export default function UnsavedChangesDialog({
  open,
  changeCount,
  loading = false,
  onStay,
  onLeaveWithoutSaving,
  onSaveAndLeave,
}: UnsavedChangesDialogProps) {
  const theme = useTheme();
  const warning = theme.palette.warning.main;

  const label = en.common.unsavedChangeCount(changeCount);

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onStay}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderColor: alpha(warning, theme.palette.mode === 'dark' ? 0.22 : 0.18),
        },
      }}
    >
      <DialogTitle
        sx={{
          bgcolor: alpha(warning, theme.palette.mode === 'dark' ? 0.2 : 0.16),
          borderBottomColor: alpha(warning, 0.35),
          color:
            theme.palette.mode === 'dark'
              ? theme.palette.warning.light
              : theme.palette.warning.dark,
        }}
      >
        {en.unsavedChanges.title}
      </DialogTitle>

      <DialogContent>
        <Typography variant="body1" sx={{ lineHeight: 1.6 }}>
          {en.unsavedChanges.body(label)}
        </Typography>
      </DialogContent>

      <DialogActions
        sx={{
          flexWrap: 'nowrap',
          '& > button': {
            flex: 1,
            minWidth: 0,
          },
        }}
      >
        <Button onClick={onLeaveWithoutSaving} disabled={loading} color="inherit">
          {en.unsavedChanges.leaveWithoutSaving}
        </Button>
        <Button
          onClick={onSaveAndLeave}
          variant="contained"
          disabled={loading}
          sx={{
            boxShadow: 'none',
            '&:hover': { boxShadow: 'none' },
          }}
        >
          {loading ? en.common.saving : en.unsavedChanges.saveAndLeave}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
